import { useState, useEffect, useContext, useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import { WebSocketContext } from '../../context/WebSocketContext';

export default function BasicTable({ columns }) {
  const { messages, sendMessage } = useContext(WebSocketContext);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const [requestedPage, setRequestedPage] = useState(null);

  const requestData = useCallback(() => {
    if (requestedPage === `${page}-${rowsPerPage}`) return; // Track rowsPerPage in requestedPage
  
    const requestPayload = {
      route: 'get_customers',
      limit: rowsPerPage,
      offset: page
    };
  
    sendMessage(requestPayload);
    setRequestedPage(`${page}-${rowsPerPage}`); // Store page and rowsPerPage together
  }, [sendMessage, page, rowsPerPage, requestedPage]);
  

  useEffect(() => {
    requestData();
  }, [page, rowsPerPage, requestData]);

  useEffect(() => {
    if (messages.length > 0) {
      const latestMessage = messages[messages.length - 1];
      if (latestMessage.customers && Array.isArray(latestMessage.customers.data)) {
        setData(latestMessage.customers.data);
        setTotalRows(latestMessage.customers.total_count || 0);
      } else if (!latestMessage.active_sessions) {
        console.warn("Unexpected WebSocket message format:", latestMessage);
      }
    }
  }, [messages]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="p-6 pt-8 rounded-2xl border">
        <p className='text-lg font-semibold text-black mb-8'>Recent Interactions</p>
        <TableContainer component={Paper} elevation={0} className="p-4 mt-7">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.Header}>{column.Header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length > 0 ? (
                data.map((row) => (
                  <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    {columns.map((column) => (
                      <TableCell key={column.accessor} align="left">
                        {row[column.accessor]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Table Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}
